export const hotkey_keyword_shift = "UXb";
export const hotkey_keyword_ctrl = "VXb";
export const hotkey_keyword_alt = "WXb";
export const hotkey_keyword_meta = "XXb";
export const hotkey_keyword_backspace = "YXb";
export const hotkey_keyword_tab = "ZXb";
export const hotkey_keyword_enter = "_Xb";
export const hotkey_keyword_return = "$Xb";
export const hotkey_keyword_capslock = "aYb";
export const hotkey_keyword_esc = "bYb";
export const hotkey_keyword_escape = "cYb";
export const hotkey_keyword_space = "dYb";
export const hotkey_keyword_pageup = "eYb";
export const hotkey_keyword_pagedown = "fYb";
export const hotkey_keyword_end = "gYb";
export const hotkey_keyword_home = "hYb";
export const hotkey_keyword_left = "iYb";
export const hotkey_keyword_up = "jYb";
export const hotkey_keyword_right = "kYb";
export const hotkey_keyword_down = "lYb";
export const hotkey_keyword_ins = "mYb";
export const hotkey_keyword_del = "nYb";
export const hotkey_keyword_command = "oYb";
export const hotkey_keyword_plus = "pYb";
export const keyboardShortcutThen = "qYb";
export default {hotkey_keyword_shift,hotkey_keyword_ctrl,hotkey_keyword_alt,hotkey_keyword_meta,hotkey_keyword_backspace,hotkey_keyword_tab,hotkey_keyword_enter,hotkey_keyword_return,hotkey_keyword_capslock,hotkey_keyword_esc,hotkey_keyword_escape,hotkey_keyword_space,hotkey_keyword_pageup,hotkey_keyword_pagedown,hotkey_keyword_end,hotkey_keyword_home,hotkey_keyword_left,hotkey_keyword_up,hotkey_keyword_right,hotkey_keyword_down,hotkey_keyword_ins,hotkey_keyword_del,hotkey_keyword_command,hotkey_keyword_plus,keyboardShortcutThen};